import React, { useEffect, useMemo, useState } from "react";
import MasterService from "../services/master/MasterService";

const StatusDok = ({kodeStatus}) => {

    let masterService = useMemo(() => new MasterService(), [])
    const [uraianStatus, setUraianStatus] = useState('')

    useEffect(() => {
        const getStatusDok = async () => {
            const response = await masterService.getStatusDokById(kodeStatus)
            setUraianStatus(response.data.uraianStatus)
        }
        getStatusDok()
    }, [masterService, kodeStatus])

    return (
        <>
            {uraianStatus}
        </>
    )
}

export default StatusDok